import * as PropTypes from 'prop-types';

import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

// Keep in sync with request_fulfillment.py
// There is additional status here PENDING that is used for aggregated values but
// is never persisted in a RequestFulfillment
export enum FulfillmentStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

// Keep in sync with FULFILLMENT_STATUS_NAMES in benchling/requests/models/request_fulfillment.py
export const FULFILLMENT_STATUS_NAMES = {
  [FulfillmentStatus.PENDING]: 'Pending',
  [FulfillmentStatus.IN_PROGRESS]: 'In progress',
  [FulfillmentStatus.COMPLETED]: 'Completed',
  [FulfillmentStatus.FAILED]: 'Marked for redo',
};

export const FULFILLMENT_STATUS_ICONS: Record<
  FulfillmentStatus,
  {className: string; icon: BenchlingIconName}
> = {
  [FulfillmentStatus.PENDING]: {
    className: 'requestFulfillment-icon--pending',
    icon: 'request-pending',
  },
  [FulfillmentStatus.IN_PROGRESS]: {
    className: 'requestFulfillment-icon--in-progress',
    icon: 'request-in-progress',
  },
  [FulfillmentStatus.COMPLETED]: {
    className: 'requestFulfillment-icon--completed',
    icon: 'request-executed',
  },
  [FulfillmentStatus.FAILED]: {
    className: 'requestFulfillment-icon--pending',
    icon: 'request-pending',
  },
};

interface RequestFulfillmentBase {
  requestId: string;
  requestTaskId: string | null;
  sampleGroupId: string | null;
  entryId?: string | null;
  workflowId?: string | null;
}

const REQUEST_FULFILLMENT_PROPS = {
  requestId: PropTypes.string.isRequired,
  requestTaskId: PropTypes.string,
  sampleGroupId: PropTypes.string,
  entryId: PropTypes.string,
  workflowId: PropTypes.string,
};

export interface RequestFulfillment extends RequestFulfillmentBase {
  id: string;
  createdAt: string;
  status: FulfillmentStatus;
  statusAfterReview: FulfillmentStatus;
}
export interface RequestFulfillmentUpdate {
  fulfillmentId: string;
  status: FulfillmentStatus;
}

// Shape of request fulfillment that is received from the server
export const REQUEST_FULFILLMENT_SHAPE = PropTypes.shape({
  ...REQUEST_FULFILLMENT_PROPS,
  id: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  status: PropTypes.oneOf(Object.values(FulfillmentStatus)).isRequired,
  statusAfterReview: PropTypes.oneOf(Object.values(FulfillmentStatus)).isRequired,
});

export interface RequestFulfillmentDefinition extends RequestFulfillmentBase {
  cid: string;
}

// Shape of the request fulfillment that is created on the client before it is persisted on the server
export const REQUEST_FULFILLMENT_DEFINITION_SHAPE = PropTypes.shape({
  ...REQUEST_FULFILLMENT_PROPS,
  cid: PropTypes.string.isRequired,
});

export interface RequestSampleStatusCounts {
  [FulfillmentStatus.PENDING]: number;
  [FulfillmentStatus.IN_PROGRESS]: number;
  [FulfillmentStatus.COMPLETED]: number;
  [FulfillmentStatus.FAILED]: number;
}
export const REQUEST_SAMPLE_STATUS_COUNTS_SHAPE = PropTypes.shape({
  PENDING: PropTypes.number.isRequired,
  IN_PROGRESS: PropTypes.number.isRequired,
  COMPLETED: PropTypes.number.isRequired,
  FAILED: PropTypes.number.isRequired,
});
